import React from "react"
import WidthWrapper from '../../components/elements/Base/WidthWrapper';
import ContentPanel from '../../components/elements/Base/ContentPanel';
import Title from '../../components/elements/Base/Title';
import MetaElement from "../../components/elements/MetaElement";

const PoliticaUtilizareCookies = (props) => {
    return (
        <WidthWrapper className="xsmall">
            <MetaElement pageId="info/politica-utilizare-cookies" />

            <ContentPanel>
                <Title variant="title">Politica de utilizare Cookies</Title>
                <p>Această politică se referă la cookie-urile si tehnologiile similare folosite pe site-ul www.krit.ro operat de Snow Software Studio S.R.L., cu sediul social în Ploiesti, str. Spătarul Nicolae Milescu nr. 14A.</p>

                <p>Cookie-urile sunt folosite pentru următoarele scopuri:</p>

                <ul>
                    <li>de funcționare a site-ului;</li>
                    <li>pentru a analiza comportamentul vizitatorilor site-ului;</li>
                    <li>pentru publicitate.</li>
                </ul>
                <p>Această politică se completează cu politica Krit cu privire la protecția datelor personale (aflat pe Site în secțiunea "Politica de Confidențialitate" și cu Termenii și Condițiile Site-ului (aflat pe Site în secțiunea "Termeni și Condiții) pe care le puteți citi pe Site-ul nostru.</p>

                <Title variant="subtitle">CE SUNT COOKIE-URILE</Title>

                <p>Cookie-ul este un fișier de dimensiuni mici, format din text, care va fi stocat pe computerul dumneavoastră sau pe smartphone-ul dumneavoastră sau orice alt echipament de pe care se accesează browser-ul Web. Cookie-ul este instalat prin solicitarea emisă de către terminalul utilizatorului către un server Krit sau către un server al unei terțe părți.</p>

                <Title variant="subtitle">LA CE SUNT FOLOSITE COOKIE-URILE</Title>

                <p>Aceste fișiere fac posibilă recunoașterea terminalului utilizatorului și prezentarea conținutului într-un mod relevant, adaptat preferințelor utilizatorului. Cookie-urile asigură utilizatorului o experiență plăcută de navigare cum ar fi funcționarea corectă a coșului de cumpărături, personalizarea cât mai buna a paginilor noastre web, conform cerințelor dumneavoastră.</p>

                <p>De asemenea, cookie-urile sunt utilizate în pregătirea unor statistici anonime care ne ajută să înțelegem cum utilizatorii beneficiază de paginile noastre, permițându-ne îmbunătățirea structurii și conținutului lor, fără a permite identificarea personală a utilizatorului.</p>

                <Title variant="subtitle">CE COOKIE-URI FOLOSIM</Title>

                <p>Cookie-urile utilizate pe site-ul nostru sunt de 2 tipuri. Cookie-urile de scurtă durată numite și "cookie-uri de sesiune", sunt fișiere temporare care sunt șterse în momentul în care părăsiți pagina noastră. Cookie-urile fixe rămân pe terminalul utilizatorului pe o perioadă determinată de parametrii cookie-ului sau până când sunt șterse manual de utilizator.</p>

                <Title variant="subtitle">CUM SUNT FOLOSITE COOKIE-URILE</Title>



                <p>În urma unei vizitei pe Site-ul nostru, pot apărea următoarele tipuri de  cookie-uri:</p>
                <ul>
                    <li>cookie-uri de analiză</li>
                    <li>cookie-uri pentru publicitate</li>
                    <li>cookie-uri necesare pentru funcționarea Site-ului</li>
                </ul>
                <p>Cookie-urile și tehnologiile similare sunt esențiale pentru buna funcționare a Site-ului, fiind setate pe calculatorul/telefonul/aparatul dumneavoastră după accesarea Site-ului sau în urma acțiunilor efectuate pe Site, după caz. Puteți seta browser-ul dumneavoastră pentru a bloca cookie-urile, însa în acest caz anumite secțiuni ale Site-ului nu vor mai funcționa corect.</p>

                <Title variant="subtitle">BLOCARE COOKIE-URI</Title>

                <p>În cazul în care doriți să blocați cookie-urile, unele funcționalități ale Site-ului vor fi oprite, acest lucru rezultând într-o experiență neplăcută pe Site-ul nostru. De exemplu, blocarea cookie-urilor vă poate împiedica în a cumpără de pe Site-ul nostru sau în a întâmpina probleme încercând să accesați contul dumneavoastră.</p>



                <p>În cazul în care doriți să blocați cookie-urile, aveți posibilitatea de a seta din browser-ul dumneavoastră blocarea acestora sau reducerea la anumite tipuri a acestora.</p>

                <p>Puteți găsi informații despre setarea preferințelor privind cookie-uri accesând link-urile de mai jos în funcție de browser-ul Web folosit:</p>

                <a href="https://support.microsoft.com/ro-ro/help/17442/windows-internet-explorer-delete-manage-cookies">Internet Explorer</a>

                <a href="https://support.google.com/accounts/answer/61416?hl=ro&co=GENIE.Platform%3DDesktop&oco=1">Chrome</a>

                <a href="https://support.mozilla.org/ro/kb/activarea-si-dezactivarea-cookie-urilor">Firefox</a>

                <p>Link-urile mai sus menționate nu aparțin site-ului Krit și Krit nu este responsabil pentru conținutul acestora.</p>

                <Title variant="subtitle">ADMINISTRAREA PREFERINȚELOR CU PRIVIRE LA PLASAREA DE COOKIE-URI</Title>

                <p>Krit folosește serviciile următoarelor terțe părți în scopul oferirii de funcționalități, pentru analiză și publicitate. Este posibil ca terțele părți menționate mai jos să folosească cookie-uri pe website-ul operat de Krit, precum și pe alte website-uri care nu sunt operate de Krit. Pentru mai multe detalii, consultați politicile de protecție a datelor precum și ghidurile de administrare a preferințelor utilizatorilor:</p>

                <strong>Google Ads</strong>

                <p>Scop: Publicitate<br />
                Politici: https://policies.google.com/privacy, https://policies.google.com/technologies/ads</p>

                <strong>Facebook</strong>

                <p>Scop: Publicitate<br />
                Politici: https://www.facebook.com/privacy/explanation</p>

                <Title variant="subtitle">LINKURI UTILE</Title>

                <p>Dacă doriți să aflați mai multe informații despre cookie-uri și la ce sunt utilizate, va recomandăm următorul link: http://www.youronlinechoices.com/ro/</p>


            </ContentPanel>
        </WidthWrapper>
    )
}

export default PoliticaUtilizareCookies;